import React from 'react';
import { Loader, Text } from '@ui';
import { translate } from '@utils/i18n';
const namespace = 'inspection_series.edit_end_date_modal';
/**
 * Says how many inspections the pending date change will cancel. The `unavailable` branch never
 * renders a number, because a wrong zero here reads as "this is safe".
 */
export default function CancelCountNotice({ state }) {
    if (state.status === 'idle')
        return null;
    if (state.status === 'loading') {
        return React.createElement(Loader, { size: "24", "data-testid": "cancel-count-loading" });
    }
    if (state.status === 'unavailable') {
        return (React.createElement(Text, { variant: "body", as: "p", "data-testid": "cancel-count-unavailable" },
            React.createElement("i", { className: "fa-light fa-triangle-exclamation" }),
            " ",
            translate('count_unavailable', { namespace })));
    }
    return (React.createElement("div", { "data-testid": "cancel-count-ready" },
        React.createElement(Text, { variant: "body", as: "p" }, translate('cancel_warning', { namespace, count: state.count }))));
}
